/**
 * Author Markus Sundin
 * Jquery plugin for an animated progressbar
 */
(function($){
    $.fn.progressBar = function( data, options ) {
        var self = this;
        this.elements = [];
        this.data = data;
        this.animating = false;
        this.elementContainer = null;

        // Default options
        this.defaults = {
            animationTime: 500,
            animationDuration: 500
        };

        // Options
        this.options = $.extend( {}, this.defaults, options );

        this.init = function() {
            $.each(data, function( progressBarName, items ) {
                var progressBarcontainer = $("<div class='m-progress-bar-container'></div>");
                var progressBarLabel = $("<div class='m-progress-bar-label'></div>");
                var progressBar = $("<div class='m-progress-bar'></div>");
                $(progressBarLabel).html( progressBarName );

                $.each(items, function(i, stepData) {
                    var step = $("<div class='m-step'><div class='m-step-name'></div></div>");
                    step.attr("data-color", stepData.Color);
                    step.attr("title", stepData.Tooltip);
                    $(".m-step-name", step).html( stepData.StepName );
                    $(progressBar).append(step);
                });

                progressBarcontainer.append( progressBar );
                progressBarcontainer.prepend( progressBarLabel );

                $( self ).append( progressBarcontainer );
                self.elements.push( progressBarcontainer );
            });
        }
        this.animate = function() {
            if(!self.animating)
            {
                self.animating = true;

                $(".m-step").removeClass(function (index, css) {
                    return (css.match (/\bm-animate-\S+/g) || []).join(' ');
                });

                var stepsToAnimate = $(".m-step", self).length;

                $.each(this.elements, function(index, bar) {
                    var timeOffset = 0;
                    $(".m-step", bar).each(function(i, step) {
                        setTimeout(function(){
                            var color = $(step).attr("data-color");
                            $(step).addClass("m-animate-" + color).css("animation-duration", self.options.animationDuration);
                            stepsToAnimate--;

                            if(stepsToAnimate < 1) {
                                self.animating = false;
                            }

                        }, timeOffset);
                        timeOffset = timeOffset + self.options.animationTime;
                    });

                });
                return self;
            }
        }

        this.init();
        return this;
    };
}(jQuery));
